import React from 'react'
import Link from '@mui/material/Link'
import Stack from '@mui/material/Stack'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'
import useFrontEndConfig from '../generic/hooks/useFrontEndConfig/useFrontEndConfig'
import { buildDashboardHref, deliveryDashboardParams, isDashboardUrlConfigured } from './planMetricsDashboardLink'

/**
 * Story 175, CU13 (S151-S153) -- the footer link of the details table to the MIC-4293 "Delays and advances"
 * dashboard: its own installation URL (`planMetricsDeliveryDashboardUrl`), the plan and the global filters
 * (contract §5), in a new tab so the Planner keeps its state (RN50). Without a URL, nothing is painted.
 */
const DeliveryDashboardLink = ({ planificationId, plannerFilters }) => {
  const { t_ } = useSmartTranslation()
  const [config] = useFrontEndConfig()
  const baseUrl = config ? config.planMetricsDeliveryDashboardUrl : undefined
  if (!isDashboardUrlConfigured(baseUrl)) {
    return null
  }
  return (
    <Stack direction='row' justifyContent='flex-end' sx={{ marginTop: 1 }}>
      {/* Contract §5 freezes rel="noopener" (a new tab that keeps the Planner's state, RN50). */}
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <Link
        href={buildDashboardHref(baseUrl, deliveryDashboardParams({ planificationId, plannerFilters }))}
        target='_blank'
        rel='noopener'
        variant='body2'
      >
        {t_('Dashboards › Delays and advances')}
      </Link>
    </Stack>
  )
}

export default DeliveryDashboardLink
